// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Tabs,
//   Tab,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   IconButton,
//   Tooltip,
//   CircularProgress,
//   Divider,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   FormLabel,
//   Chip,
//   Alert,
// } from "@mui/material";
// import {
//   Add,
//   Delete,
//   Edit,
//   Visibility,
//   Print,
//   Refresh,
//   OpenInNew,
//   CheckCircle,
//   Cancel,
//   FlagCircle,
// } from "@mui/icons-material";
// import { useSelector } from "react-redux";
// import api from "../../../../api/axiosInterceptor";
// import { SnackBarComponent } from "../../../../Components/snackBar/snackBar";
// import { LoadingSpinner } from "../../../../Components/spinner/spinner";
// import TableComponent from "../../../../Components/TableComponent/TableComponent";
// import FEDropdown from "../feDropdown";

// // ─────────────────────────────────────────────────────────────────────────────
// // CONSTANTS
// // ─────────────────────────────────────────────────────────────────────────────
// const TODAY = new Date().toISOString().split("T")[0];

// const CATEGORY_OPTIONS = [
//   "Computers & IT Peripherals","HVAC","Furniture & Fixtures",
//   "Electrical Equipment","Vehicles","Machinery",
//   "Jewellery & Valuables","Cash & Cash Equivalents","Office Equipment","Other",
// ];

// const CONDITION_OPTIONS = ["Serviceable","Unused","Damaged","Scrap","Under Repair"];

// const IMMOV_CATEGORY_OPTIONS = [
//   "Land","Building","Land & Building","Agricultural Land",
//   "Commercial Property","Residential Property","Industrial Property","Other",
// ];

// const IMMOV_SUBCATEGORY_OPTIONS = [
//   "Plot","Apartment","Villa","Office Space","Warehouse","Factory","Farm Land","Other",
// ];

// const CONDITION_STATUS_OPTIONS = ["Good","Average","Poor","Dilapidated"];

// const STATUS_META = {
//   draft:            { label: "Draft",                  color: "default" },
//   submitted:        { label: "Submitted",              color: "primary" },
//   approved_shira:   { label: "Approved (Shirastedar)", color: "success" },
//   rejected_shira:   { label: "Rejected (Shirastedar)", color: "error"   },
//   approved_tahsil:  { label: "Approved (Tahsildar)",   color: "success" },
//   rejected_tahsil:  { label: "Rejected (Tahsildar)",   color: "error"   },
//   approved_ac:      { label: "Approved (AC)",          color: "success" },
//   rejected_ac:      { label: "Rejected (AC)",          color: "error"   },
//   approved_js:      { label: "Approved (JS)",          color: "success" },
//   rejected_js:      { label: "Rejected (JS)",          color: "error"   },
//   approved_sploca:  { label: "Approved (SPLOCA)",      color: "success" },
//   rejected_sploca:  { label: "Rejected (SPLOCA)",      color: "error"   },
//   approved_ca:      { label: "Approved (CA)",          color: "success" },
//   rejected_ca:      { label: "Rejected (CA)",          color: "error"   },
//   approved_rc:      { label: "Approved (RC)",          color: "success" },
//   rejected_rc:      { label: "Rejected (RC)",          color: "error"   },
//   final:            { label: "Finalised",              color: "success" },
// };

// const StatusChip = ({ status }) => {
//   const m = STATUS_META[status] || { label: status, color: "default" };
//   return <Chip label={m.label} color={m.color} size="small" />;
// };

// const EDITABLE = [
//   "draft","rejected_shira","rejected_tahsil","rejected_ac",
//   "rejected_js","rejected_sploca","rejected_ca","rejected_rc",
// ];

// // ─────────────────────────────────────────────────────────────────────────────
// // SHARED HELPERS
// // ─────────────────────────────────────────────────────────────────────────────
// const TF = ({ label, value, onChange, type = "text", disabled, multiline, rows, sx = {} }) => (
//   <TextField
//     label={label}
//     value={value ?? ""}
//     size="small"
//     fullWidth
//     type={type}
//     disabled={disabled}
//     multiline={multiline}
//     rows={rows}
//     InputLabelProps={type === "date" ? { shrink: true } : undefined}
//     onChange={onChange ? (e) => onChange(e.target.value) : undefined}
//     sx={sx}
//   />
// );

// const FG = ({ children, cols = 3, sx = {} }) => (
//   <Box sx={{ display: "grid", gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 2, mb: 2, ...sx }}>
//     {children}
//   </Box>
// );

// const SecHead = ({ label }) => (
//   <Box sx={{ background: "#1976d2", color: "#fff", px: 2, py: 1, borderRadius: 1, mb: 1 }}>
//     <Typography variant="body2" fontWeight="bold">{label}</Typography>
//   </Box>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // FORM HEADER
// // ─────────────────────────────────────────────────────────────────────────────
// const FormHeader = ({ d, ro, set, onFESelect, showFormId = false }) => (
//   <Box>
//     {showFormId && d.form_id && (
//       <Box sx={{ mb: 2, p: 1.5, background: "#e3f2fd", borderRadius: 1, display: "flex", gap: 2, alignItems: "center" }}>
//         <Typography variant="body2" fontWeight="bold" color="primary">Form ID:</Typography>
//         <Typography variant="body1" fontWeight="bold">{d.form_id}</Typography>
//       </Box>
//     )}

//     {!ro && (
//       <Box sx={{ mb: 2 }}>
//         <FormControl>
//           <FormLabel><Typography variant="body2" fontWeight="bold">Office Type</Typography></FormLabel>
//           <RadioGroup row value={d.office_type || "sploca"} onChange={(e) => set("office_type", e.target.value)}>
//             <FormControlLabel value="sploca" control={<Radio size="small" />} label="SPLOCA" />
//             <FormControlLabel value="rc"     control={<Radio size="small" />} label="RC" />
//           </RadioGroup>
//         </FormControl>
//       </Box>
//     )}
//     {ro && d.office_type && (
//       <Box sx={{ mb: 1 }}>
//         <Typography variant="caption" color="text.secondary">Office Type: </Typography>
//         <Chip label={d.office_type?.toUpperCase()} size="small" color="info" sx={{ ml: 0.5 }} />
//       </Box>
//     )}

//     <FG cols={3}>
//       <Box>
//         <Typography variant="caption" sx={{ color: "#d32f2f" }}>Financial Establishment *</Typography>
//         {ro ? (
//           <Typography variant="body2" fontWeight="bold">{d.fe_detail?.name_of_fe || ""}</Typography>
//         ) : (
//           <FEDropdown value={d.fe} disabled={false} onSelect={(fe) => onFESelect && onFESelect(fe)} />
//         )}
//       </Box>
//       <Box>
//         <Typography variant="caption" color="text.secondary">Seized Stores of</Typography>
//         <TF value={d.seized_stores_of} disabled={ro} onChange={ro ? null : (v) => set("seized_stores_of", v)} />
//       </Box>
//       <Box>
//         <Typography variant="caption" color="text.secondary">Date of Seizure</Typography>
//         <TF type="date" value={d.date_of_seizure} disabled={ro} onChange={ro ? null : (v) => set("date_of_seizure", v)} />
//       </Box>
//       <Box>
//         <Typography variant="caption" color="text.secondary">Date of Handover</Typography>
//         <TF type="date" value={d.date_of_handover} disabled={ro} onChange={ro ? null : (v) => set("date_of_handover", v)} />
//       </Box>
//       <Box>
//         <Typography variant="caption" color="text.secondary">Handover By</Typography>
//         <TF value={d.handover_by} disabled={ro} onChange={ro ? null : (v) => set("handover_by", v)} />
//       </Box>
//       <Box>
//         <Typography variant="caption" color="text.secondary">Takeover By CA</Typography>
//         <TF value={d.takeover_by_ca} disabled={ro} onChange={ro ? null : (v) => set("takeover_by_ca", v)} />
//       </Box>
//       <Box>
//         <Typography variant="caption" color="text.secondary">Location of Store</Typography>
//         <TF value={d.location_of_store} disabled={ro} onChange={ro ? null : (v) => set("location_of_store", v)} />
//       </Box>
//       <Box>
//         <Typography variant="caption" color="text.secondary">Seized Stores Officer</Typography>
//         <TF value={d.seized_stores_officer} disabled={ro} onChange={ro ? null : (v) => set("seized_stores_officer", v)} />
//       </Box>
//       <Box>
//         <Typography variant="caption" color="text.secondary">Date of Sanction by Court</Typography>
//         <TF type="date" value={d.date_of_sanction_by_court} disabled={ro} onChange={ro ? null : (v) => set("date_of_sanction_by_court", v)} />
//       </Box>
//     </FG>
//   </Box>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // APPROVAL TRAIL  (read-only history of who did what)
// // ─────────────────────────────────────────────────────────────────────────────
// const TRAIL_FIELDS = [
//   { key: "shirastedar", label: "Shirastedar" },
//   { key: "tahsildar",   label: "Tahsildar"   },
//   { key: "ac",          label: "AC"          },
//   { key: "js",          label: "JS"          },
//   { key: "sploca",      label: "SPLOCA"      },
//   { key: "ca",          label: "CA"          },
//   { key: "rc",          label: "RC"          },
// ];

// const ApprovalTrail = ({ form }) => {
//   const entries = TRAIL_FIELDS.filter(
//     (f) => form[`${f.key}_by`] || form[`${f.key}_at`] || form[`${f.key}_remarks`]
//   );
//   if (!entries.length) return null;

//   return (
//     <Box sx={{ mt: 2, mb: 1 }}>
//       <Typography variant="subtitle2" fontWeight="bold" mb={1} color="text.secondary">
//         Approval Trail
//       </Typography>
//       <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//         {entries.map((f) => (
//           <Box key={f.key} sx={{ display: "flex", gap: 2, p: 1.5, background: "#f5f5f5", borderRadius: 1, alignItems: "flex-start" }}>
//             <Box sx={{ minWidth: 100 }}>
//               <Typography variant="caption" fontWeight="bold" color="text.secondary">{f.label}</Typography>
//             </Box>
//             <Box sx={{ flex: 1 }}>
//               {form[`${f.key}_by`] && (
//                 <Typography variant="caption" display="block">
//                   By: <strong>{form[`${f.key}_by`]}</strong>
//                 </Typography>
//               )}
//               {form[`${f.key}_at`] && (
//                 <Typography variant="caption" display="block" color="text.secondary">
//                   At: {new Date(form[`${f.key}_at`]).toLocaleString()}
//                 </Typography>
//               )}
//               {form[`${f.key}_remarks`] && (
//                 <Typography variant="caption" display="block" sx={{ mt: 0.5, color: "#555", fontStyle: "italic" }}>
//                   Remarks: {form[`${f.key}_remarks`]}
//                 </Typography>
//               )}
//             </Box>
//           </Box>
//         ))}
//       </Box>
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // APPROVAL PANEL — driven by available_actions from the backend
// // ─────────────────────────────────────────────────────────────────────────────
// const ApprovalPanel = ({ form, apiPath, onRefresh }) => {
//   const [remarks, setRemarks] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [snack, setSnack] = useState({ open: false, message: "", severity: "info" });

//   // available_actions comes from the GET detail response (set by backend per user role)
//   const available = form.available_actions || [];

//   const doAction = async (action) => {
//     setLoading(true);
//     try {
//       await api.post(`${apiPath}${form.id}/action/`, { action, remarks });
//       setSnack({ open: true, message: "Action completed successfully", severity: "success" });
//       onRefresh();
//     } catch (e) {
//       setSnack({ open: true, message: e.response?.data?.error || "Action failed", severity: "error" });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getIcon = (color) => {
//     if (color === "success") return <CheckCircle fontSize="small" />;
//     if (color === "error")   return <Cancel fontSize="small" />;
//     return <FlagCircle fontSize="small" />;
//   };

//   if (form.status === "final") {
//     return (
//       <Box sx={{ mt: 3, p: 2, border: "1px solid #c8e6c9", borderRadius: 2, background: "#f1f8e9" }}>
//         <Typography variant="subtitle2" color="success.main" fontWeight="bold">
//           ✓ This form has been finalised
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ mt: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 2, background: "#f5f5f5" }}>
//       <Typography variant="subtitle2" fontWeight="bold" mb={1}>Available Actions</Typography>

//       {available.length === 0 ? (
//         <Alert severity="info" sx={{ mt: 1 }}>
//           No actions available for your role at this stage.
//         </Alert>
//       ) : (
//         <>
//           <Box sx={{ mb: 2, p: 1.5, background: "#fff3e0", borderRadius: 1, border: "1px solid #ffe0b2" }}>
//             <Typography variant="caption" color="text.secondary">
//               <strong>Flexible flow:</strong> Actions below are available to your role at this stage.
//               You can approve or finalise without waiting for other approvals.
//             </Typography>
//           </Box>
//           <TextField
//             fullWidth size="small" label="Remarks (optional)"
//             value={remarks} onChange={(e) => setRemarks(e.target.value)}
//             multiline rows={2} sx={{ mb: 2, background: "#fff" }}
//           />
//           <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//             {available.map((a) => (
//               <Button
//                 key={a.action}
//                 variant="contained"
//                 color={a.color}
//                 size="small"
//                 disabled={loading}
//                 onClick={() => doAction(a.action)}
//                 startIcon={loading ? <CircularProgress size={14} /> : getIcon(a.color)}
//               >
//                 {a.label}
//               </Button>
//             ))}
//           </Box>
//         </>
//       )}
//       <SnackBarComponent
//         open={snack.open} message={snack.message} severity={snack.severity}
//         onClose={() => setSnack((s) => ({ ...s, open: false }))}
//       />
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // MOVABLE ITEM EDITOR
// // ─────────────────────────────────────────────────────────────────────────────
// const BLANK_ITEM = {
//   category_type: "", item_name: "", description: "", material: "",
//   quantity: "", weight: "", brand: "", model_no: "", make: "",
//   condition: "", condition_detail: "",
//   stored_in_area_no: "", room_no: "", floor: "", address: "",
//   assigned_sold_to: "", assigned_date: "", release_to: "", release_date: "",
//   unit_price: "", book_value: "", estimated_value_auction: "",
//   obsolescence_percentage: "", total_reserve_price: "",
//   floor_price: "", depreciation_percentage: "",
// };

// const MovableItemEditor = ({ item, idx, ro, onChange }) => {
//   const s = (f, v) => onChange(idx, f, v);

//   return (
//     <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2, mb: 2, background: idx % 2 === 0 ? "#fafafa" : "#fff" }}>
//       <Box sx={{ background: "#1976d2", color: "#fff", px: 2, py: 0.5, borderRadius: 1, mb: 2 }}>
//         <Typography variant="body2" fontWeight="bold">{idx + 1}</Typography>
//       </Box>

//       <Box sx={{ mb: 2 }}>
//         <Typography variant="caption" color="text.secondary">Category & Type</Typography>
//         {ro ? (
//           <Typography variant="body2">{item.category_type}</Typography>
//         ) : (
//           <FormControl size="small" fullWidth>
//             <Select value={item.category_type || ""} displayEmpty onChange={(e) => s("category_type", e.target.value)}>
//               <MenuItem value=""><em>Select Category</em></MenuItem>
//               {CATEGORY_OPTIONS.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
//             </Select>
//           </FormControl>
//         )}
//       </Box>

//       <FG cols={3}>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Item Name</Typography>
//           <TF value={item.item_name} disabled={ro} onChange={ro ? null : (v) => s("item_name", v)} />
//         </Box>
//         <Box sx={{ gridColumn: "span 1" }}>
//           <Typography variant="caption" color="text.secondary">Description</Typography>
//           <TF value={item.description} disabled={ro} multiline rows={2} onChange={ro ? null : (v) => s("description", v)} />
//         </Box>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Material</Typography>
//           <TF value={item.material} disabled={ro} onChange={ro ? null : (v) => s("material", v)} />
//         </Box>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Quantity</Typography>
//           <TF value={item.quantity} disabled={ro} onChange={ro ? null : (v) => s("quantity", v)} />
//         </Box>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Weight</Typography>
//           <TF value={item.weight} disabled={ro} onChange={ro ? null : (v) => s("weight", v)} />
//         </Box>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Brand</Typography>
//           <TF value={item.brand} disabled={ro} onChange={ro ? null : (v) => s("brand", v)} />
//         </Box>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Model</Typography>
//           <TF value={item.model_no} disabled={ro} onChange={ro ? null : (v) => s("model_no", v)} />
//         </Box>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Make</Typography>
//           <TF value={item.make} disabled={ro} onChange={ro ? null : (v) => s("make", v)} />
//         </Box>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Condition</Typography>
//           {ro ? (
//             <Typography variant="body2">{item.condition}</Typography>
//           ) : (
//             <FormControl size="small" fullWidth>
//               <Select value={item.condition || ""} displayEmpty onChange={(e) => s("condition", e.target.value)}>
//                 <MenuItem value=""><em>Select</em></MenuItem>
//                 {CONDITION_OPTIONS.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
//               </Select>
//             </FormControl>
//           )}
//         </Box>
//         <Box sx={{ gridColumn: "span 2" }}>
//           <Typography variant="caption" color="text.secondary">Condition Detail</Typography>
//           <TF value={item.condition_detail} disabled={ro} onChange={ro ? null : (v) => s("condition_detail", v)} />
//         </Box>
//       </FG>

//       {/* Valuation section */}
//       <Box sx={{ border: "2px solid #f44336", borderRadius: 2, p: 2, mt: 1, mb: 2 }}>
//         <Typography variant="caption" fontWeight="bold" color="error" display="block" mb={1}>
//           Valuation Details
//         </Typography>
//         <FG cols={2}>
//           {[
//             { f: "unit_price",               l: "Unit Price" },
//             { f: "book_value",               l: "Book Value" },
//             { f: "estimated_value_auction",  l: "Estimated Value (Year of Auction)" },
//             { f: "obsolescence_percentage",  l: "Obsolescence Percentage" },
//             { f: "total_reserve_price",      l: "Total Reserve Price" },
//             { f: "floor_price",              l: "Floor Price" },
//             { f: "depreciation_percentage",  l: "Depreciation Percentage" },
//           ].map(({ f, l }) => (
//             <Box key={f}>
//               <Typography variant="caption" color="text.secondary">{l}</Typography>
//               <TF type="number" value={item[f]} disabled={ro} onChange={ro ? null : (v) => s(f, v)} />
//             </Box>
//           ))}
//         </FG>
//       </Box>

//       {/* Storage Details */}
//       <Divider sx={{ my: 1 }} />
//       <Typography variant="caption" fontWeight="bold" color="primary" display="block" mb={1}>
//         Storage Details
//       </Typography>
//       <FG cols={2}>
//         {[
//           { f: "stored_in_area_no", l: "Stored in Area No" },
//           { f: "room_no",           l: "Room No" },
//           { f: "floor",             l: "Floor" },
//         ].map(({ f, l }) => (
//           <Box key={f}>
//             <Typography variant="caption" color="text.secondary">{l}</Typography>
//             <TF value={item[f]} disabled={ro} onChange={ro ? null : (v) => s(f, v)} />
//           </Box>
//         ))}
//         <Box>
//           <Typography variant="caption" color="text.secondary">Address</Typography>
//           <TF value={item.address} disabled={ro} multiline rows={2} onChange={ro ? null : (v) => s("address", v)} />
//         </Box>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Assigned / Sold To</Typography>
//           <TF value={item.assigned_sold_to} disabled={ro} onChange={ro ? null : (v) => s("assigned_sold_to", v)} />
//         </Box>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Assigned Date</Typography>
//           <TF type="date" value={item.assigned_date} disabled={ro} onChange={ro ? null : (v) => s("assigned_date", v)} />
//         </Box>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Release To</Typography>
//           <TF value={item.release_to} disabled={ro} onChange={ro ? null : (v) => s("release_to", v)} />
//         </Box>
//         <Box>
//           <Typography variant="caption" color="text.secondary">Release Date</Typography>
//           <TF type="date" value={item.release_date} disabled={ro} onChange={ro ? null : (v) => s("release_date", v)} />
//         </Box>
//       </FG>

//       {!ro && (
//         <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
//           <Button size="small" color="error" startIcon={<Delete />}
//             onClick={() => onChange(idx, "__DELETE__", null)}>
//             Remove Item
//           </Button>
//         </Box>
//       )}
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // REGISTER OF SEIZED MOVABLES FORM
// // ─────────────────────────────────────────────────────────────────────────────
// const REG_BLANK = {
//   fe: null, fe_detail: null, office_type: "sploca",
//   seized_stores_of: "", date_of_seizure: "", date_of_handover: "",
//   handover_by: "", takeover_by_ca: "", location_of_store: "",
//   seized_stores_officer: "", date_of_sanction_by_court: "",
//   date: TODAY, recipient_name: "",
// };

// const RegisterSeizedMovableForm = ({ d, ro, set, items, setItems, onFESelect }) => (
//   <Box>
//     <FormHeader d={d} ro={ro} set={set} onFESelect={onFESelect} showFormId />
//     <SecHead label="Sl.No — Items" />
//     {items.map((item, idx) => (
//       <MovableItemEditor
//         key={idx} item={item} idx={idx} ro={ro}
//         onChange={(i, f, v) => {
//           if (f === "__DELETE__") { setItems((it) => it.filter((_, ri) => ri !== i)); return; }
//           setItems((it) => it.map((rw, ri) => (ri === i ? { ...rw, [f]: v } : rw)));
//         }}
//       />
//     ))}
//     {!ro && (
//       <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
//         <Button variant="outlined" startIcon={<Add />} size="small"
//           onClick={() => setItems((it) => [...it, { ...BLANK_ITEM }])}>
//           Add Item
//         </Button>
//       </Box>
//     )}
//     <FG cols={2}>
//       <Box>
//         <Typography variant="caption" color="text.secondary">Date</Typography>
//         <TF type="date" value={d.date} disabled={ro} onChange={ro ? null : (v) => set("date", v)} />
//       </Box>
//       <Box>
//         <Typography variant="caption" color="text.secondary">Recipient Name</Typography>
//         <TF value={d.recipient_name} disabled={ro} onChange={ro ? null : (v) => set("recipient_name", v)} />
//       </Box>
//     </FG>
//   </Box>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // REGISTER OF IMMOVABLES FORM
// // ─────────────────────────────────────────────────────────────────────────────
// const IMMOV_BLANK = {
//   fe: null, fe_detail: null, office_type: "sploca",
//   seized_stores_of: "", date_of_seizure: "", date_of_handover: "",
//   handover_by: "", takeover_by_ca: "", location_of_store: "",
//   seized_stores_officer: "", date_of_sanction_by_court: "",
//   asset_categorization: "", asset_sub_categorization: "",
//   name: "", description: "", category: "", date_of_acquisition: "",
//   quantity: "", unit_book_value: "", total_book_value: "",
//   location: "", police_station: "", police_station_contact: "",
//   tahsildar: "", tahsildar_contact: "",
//   depreciation_appreciation: "", npv_calculation: "", condition: "",
//   reserve_price: "", litigation_any_forum: "", case_number_in_court: "",
//   court_or_forum_name: "", details_of_decree: "", case_status: "Final",
//   brief_description_decree: "", road_approach: "", schedule: "",
//   marked_values: "", reason_for_present_marked_values: "",
// };

// const RegisterImmovableForm = ({ d, ro, set, onFESelect, onFileChange }) => (
//   <Box>
//     <FormHeader d={d} ro={ro} set={set} onFESelect={onFESelect} showFormId />

//     <SecHead label="1 — Asset Categorization" />
//     <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 1, p: 2, mb: 2 }}>
//       {/* Asset Categorization */}
//       <Box sx={{ display: "grid", gridTemplateColumns: "60px 200px 1fr", gap: 1, mb: 1, py: 1, borderBottom: "1px solid #eee", alignItems: "center" }}>
//         <Typography variant="body2">1</Typography>
//         <Typography variant="body2">Asset Categorization</Typography>
//         {ro ? (
//           <Typography variant="body2">{d.asset_categorization}</Typography>
//         ) : (
//           <FormControl size="small" fullWidth>
//             <Select value={d.asset_categorization || ""} displayEmpty onChange={(e) => set("asset_categorization", e.target.value)}>
//               <MenuItem value=""><em>Select</em></MenuItem>
//               {IMMOV_CATEGORY_OPTIONS.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
//             </Select>
//           </FormControl>
//         )}
//       </Box>

//       {/* Sub-Categorization */}
//       <Box sx={{ display: "grid", gridTemplateColumns: "60px 200px 1fr", gap: 1, mb: 1, py: 1, borderBottom: "1px solid #eee", alignItems: "center" }}>
//         <Typography variant="body2">3</Typography>
//         <Typography variant="body2">Immovable Sub-Categorization</Typography>
//         {ro ? (
//           <Typography variant="body2">{d.asset_sub_categorization}</Typography>
//         ) : (
//           <FormControl size="small" fullWidth>
//             <Select value={d.asset_sub_categorization || ""} displayEmpty onChange={(e) => set("asset_sub_categorization", e.target.value)}>
//               <MenuItem value=""><em>Select Sub-Categorization</em></MenuItem>
//               {IMMOV_SUBCATEGORY_OPTIONS.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
//             </Select>
//           </FormControl>
//         )}
//       </Box>

//       {/* Immovable Asset Details */}
//       <Box sx={{ display: "grid", gridTemplateColumns: "60px 200px 1fr", gap: 1, alignItems: "flex-start", py: 1 }}>
//         <Typography variant="body2">4</Typography>
//         <Typography variant="body2">Immovable Asset Details &amp; Status</Typography>
//         <Box>
//           {[
//             { f: "name",        l: "Name" },
//             { f: "category",    l: "Category" },
//           ].map(({ f, l }) => (
//             <Box key={f} sx={{ mb: 1 }}>
//               <Typography variant="caption" color="text.secondary">{l}</Typography>
//               <TF value={d[f]} disabled={ro} onChange={ro ? null : (v) => set(f, v)} />
//             </Box>
//           ))}
//           <Box sx={{ mb: 1 }}>
//             <Typography variant="caption" color="text.secondary">Description</Typography>
//             <TF value={d.description} disabled={ro} multiline rows={3} onChange={ro ? null : (v) => set("description", v)} />
//           </Box>
//           <FG cols={2} sx={{ mb: 1 }}>
//             <Box>
//               <Typography variant="caption" color="text.secondary">Date of Acquisition</Typography>
//               <TF type="date" value={d.date_of_acquisition} disabled={ro} onChange={ro ? null : (v) => set("date_of_acquisition", v)} />
//             </Box>
//             <Box>
//               <Typography variant="caption" color="text.secondary">Quantity</Typography>
//               <TF value={d.quantity} disabled={ro} onChange={ro ? null : (v) => set("quantity", v)} />
//             </Box>
//           </FG>
//           <FG cols={2} sx={{ mb: 1 }}>
//             <Box>
//               <Typography variant="caption" color="text.secondary">Unit Book Value</Typography>
//               <TF type="number" value={d.unit_book_value} disabled={ro} onChange={ro ? null : (v) => set("unit_book_value", v)} />
//             </Box>
//             <Box>
//               <Typography variant="caption" color="text.secondary">Total Book Value</Typography>
//               <TF type="number" value={d.total_book_value} disabled={ro} onChange={ro ? null : (v) => set("total_book_value", v)} />
//             </Box>
//           </FG>
//           <Box sx={{ mb: 1 }}>
//             <Typography variant="caption" color="text.secondary">Location</Typography>
//             <TF value={d.location} disabled={ro} multiline rows={2} onChange={ro ? null : (v) => set("location", v)} />
//           </Box>
//           <FG cols={2} sx={{ mb: 1 }}>
//             <Box>
//               <Typography variant="caption" color="text.secondary">Police Station</Typography>
//               <TF value={d.police_station} disabled={ro} onChange={ro ? null : (v) => set("police_station", v)} />
//             </Box>
//             <Box>
//               <Typography variant="caption" color="text.secondary">Police Station Contact</Typography>
//               <TF value={d.police_station_contact} disabled={ro} onChange={ro ? null : (v) => set("police_station_contact", v)} />
//             </Box>
//           </FG>
//           <FG cols={2} sx={{ mb: 1 }}>
//             <Box>
//               <Typography variant="caption" color="text.secondary">Tahsildar</Typography>
//               <TF value={d.tahsildar} disabled={ro} onChange={ro ? null : (v) => set("tahsildar", v)} />
//             </Box>
//             <Box>
//               <Typography variant="caption" color="text.secondary">Tahsildar Contact</Typography>
//               <TF value={d.tahsildar_contact} disabled={ro} onChange={ro ? null : (v) => set("tahsildar_contact", v)} />
//             </Box>
//           </FG>
//           <FG cols={2} sx={{ mb: 1 }}>
//             <Box>
//               <Typography variant="caption" color="text.secondary">Depreciation / Appreciation</Typography>
//               <TF type="number" value={d.depreciation_appreciation} disabled={ro} onChange={ro ? null : (v) => set("depreciation_appreciation", v)} />
//             </Box>
//             <Box>
//               <Typography variant="caption" color="text.secondary">NPV Calculation</Typography>
//               <TF type="number" value={d.npv_calculation} disabled={ro} onChange={ro ? null : (v) => set("npv_calculation", v)} />
//             </Box>
//           </FG>
//           <Box sx={{ mb: 1 }}>
//             <Typography variant="caption" color="text.secondary">Condition</Typography>
//             {ro ? (
//               <Typography variant="body2">{d.condition}</Typography>
//             ) : (
//               <FormControl size="small" fullWidth>
//                 <Select value={d.condition || ""} displayEmpty onChange={(e) => set("condition", e.target.value)}>
//                   <MenuItem value=""><em>-Select-</em></MenuItem>
//                   {CONDITION_STATUS_OPTIONS.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
//                 </Select>
//               </FormControl>
//             )}
//           </Box>
//           <Box sx={{ mb: 1 }}>
//             <Typography variant="caption" color="text.secondary">Reserve Price</Typography>
//             <TF type="number" value={d.reserve_price} disabled={ro} onChange={ro ? null : (v) => set("reserve_price", v)} />
//           </Box>

//           {/* Court Cases */}
//           <Typography variant="body2" fontWeight="bold" sx={{ mt: 2, mb: 1 }}>Court Cases if any</Typography>
//           {[
//             { f: "litigation_any_forum",  l: "Litigation in Any Forum" },
//             { f: "case_number_in_court",  l: "Case Number in Court" },
//             { f: "court_or_forum_name",   l: "Court Or Forum Name" },
//           ].map(({ f, l }) => (
//             <Box key={f} sx={{ mb: 1 }}>
//               <Typography variant="caption" color="text.secondary">{l}</Typography>
//               <TF value={d[f]} disabled={ro} onChange={ro ? null : (v) => set(f, v)} />
//             </Box>
//           ))}
//           <Box sx={{ mb: 1 }}>
//             <Typography variant="caption" color="text.secondary">Details of any Decree</Typography>
//             <TF value={d.details_of_decree} disabled={ro} multiline rows={3} onChange={ro ? null : (v) => set("details_of_decree", v)} />
//           </Box>
//           <Box sx={{ mb: 1 }}>
//             <Typography variant="caption" color="text.secondary">Status</Typography>
//             {ro ? (
//               <Typography variant="body2">{d.case_status}</Typography>
//             ) : (
//               <FormControl size="small" fullWidth>
//                 <Select value={d.case_status || "Final"} onChange={(e) => set("case_status", e.target.value)}>
//                   {["Final","Pending","Disposed"].map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
//                 </Select>
//               </FormControl>
//             )}
//           </Box>
//           <Box sx={{ mb: 1 }}>
//             <Typography variant="caption" color="text.secondary">Brief Description of Decree</Typography>
//             <TF value={d.brief_description_decree} disabled={ro} multiline rows={2}
//               onChange={ro ? null : (v) => set("brief_description_decree", v)} />
//           </Box>

//           {!ro ? (
//             <Box sx={{ mb: 1 }}>
//               <Typography variant="caption" color="text.secondary">Upload copy of Decree</Typography>
//               <Box sx={{ mt: 0.5 }}>
//                 <input type="file" accept=".pdf,.jpg,.jpeg,.png"
//                   onChange={(e) => onFileChange && onFileChange(e.target.files[0])} />
//               </Box>
//             </Box>
//           ) : (
//             d.upload_copy_of_decree && (
//               <Box sx={{ mb: 1 }}>
//                 <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>Copy of Decree</Typography>
//                 <Button variant="outlined" size="small" startIcon={<OpenInNew fontSize="small" />}
//                   onClick={() => window.open(d.upload_copy_of_decree, "_blank")}>
//                   View Decree Document
//                 </Button>
//               </Box>
//             )
//           )}
//         </Box>
//       </Box>

//       {/* Guidelines values */}
//       <Box sx={{ display: "grid", gridTemplateColumns: "60px 200px 1fr", gap: 1, py: 1, borderTop: "1px solid #eee", alignItems: "flex-start" }}>
//         <Typography variant="body2">6</Typography>
//         <Typography variant="body2">Immovable</Typography>
//         <Box>
//           <Typography variant="caption" color="text.secondary" display="block" mb={1}>Guidelines values</Typography>
//           <FG cols={2}>
//             <Box>
//               <Typography variant="caption" color="text.secondary">Road Approach</Typography>
//               {ro ? (
//                 <Typography variant="body2">{d.road_approach}</Typography>
//               ) : (
//                 <FormControl size="small" fullWidth>
//                   <Select value={d.road_approach || ""} displayEmpty onChange={(e) => set("road_approach", e.target.value)}>
//                     <MenuItem value=""><em>Select</em></MenuItem>
//                     <MenuItem value="Yes">Yes</MenuItem>
//                     <MenuItem value="No">No</MenuItem>
//                   </Select>
//                 </FormControl>
//               )}
//             </Box>
//             <Box>
//               <Typography variant="caption" color="text.secondary">Schedule</Typography>
//               {ro ? (
//                 <Typography variant="body2">{d.schedule}</Typography>
//               ) : (
//                 <FormControl size="small" fullWidth>
//                   <Select value={d.schedule || ""} displayEmpty onChange={(e) => set("schedule", e.target.value)}>
//                     <MenuItem value=""><em>Select</em></MenuItem>
//                     {["I","II","III","IV","V"].map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
//                   </Select>
//                 </FormControl>
//               )}
//             </Box>
//           </FG>
//           <Box sx={{ mb: 1 }}>
//             <Typography variant="caption" color="text.secondary">Marked values</Typography>
//             <TF value={d.marked_values} disabled={ro} onChange={ro ? null : (v) => set("marked_values", v)} />
//           </Box>
//           <Box>
//             <Typography variant="caption" sx={{ color: "#f57c00" }}>Reason for fixing present marked values</Typography>
//             <TF value={d.reason_for_present_marked_values} disabled={ro} multiline rows={3}
//               onChange={ro ? null : (v) => set("reason_for_present_marked_values", v)} />
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   </Box>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // GENERIC FORM MANAGEMENT HOOK
// // ─────────────────────────────────────────────────────────────────────────────
// const useFormManager = (ep, blank, blankItem = null) => {
//   const [view, setView]         = useState("list");
//   const [list, setList]         = useState([]);
//   const [loading, setLoading]   = useState(false);
//   const [formData, setFormData] = useState({ ...blank });
//   const [items, setItems]       = useState(blankItem ? [{ ...blankItem }] : []);
//   const [selected, setSelected] = useState(null);
//   const [saving, setSaving]     = useState(false);
//   const [snack, setSnack]       = useState({ open: false, message: "", severity: "info" });
//   const [decreeFile, setDecreeFile] = useState(null);

//   const fetchList = useCallback(async () => {
//     setLoading(true);
//     try {
//       const r = await api.get(ep);
//       setList(r.data);
//     } catch {
//       setSnack({ open: true, message: "Failed to load", severity: "error" });
//     } finally {
//       setLoading(false);
//     }
//   }, [ep]);

//   useEffect(() => { fetchList(); }, []);

//   const set = (f, v) => setFormData((d) => ({ ...d, [f]: v }));

//   const handleFESelect = (fe) => {
//     if (!fe) return;
//     setFormData((d) => ({ ...d, fe: fe.id, fe_detail: fe }));
//   };

//   const openNew = () => {
//     setFormData({ ...blank });
//     setItems(blankItem ? [{ ...blankItem }] : []);
//     setSelected(null);
//     setDecreeFile(null);
//     setView("form");
//   };

//   const openEdit = (item) => {
//     setFormData({ ...item });
//     setItems(item.items || []);
//     setSelected(item);
//     setDecreeFile(null);
//     setView("form");
//   };

//   // Detail view fetches fresh data from backend (includes available_actions per user role)
//   const openView = async (item) => {
//     try {
//       const r = await api.get(`${ep}${item.id}/`);
//       setFormData(r.data);
//       setItems(r.data.items || []);
//       setSelected(r.data);
//     } catch {
//       setFormData(item);
//       setItems(item.items || []);
//       setSelected(item);
//     }
//     setView("detail");
//   };

//   // Refresh detail (called after an approval action)
//   const refreshDetail = async () => {
//     if (!selected?.id) return;
//     try {
//       const r = await api.get(`${ep}${selected.id}/`);
//       setFormData(r.data);
//       setItems(r.data.items || []);
//       setSelected(r.data);
//     } catch {/* ignore */}
//   };

//   const handleSave = async () => {
//     setSaving(true);
//     const { fe_detail, available_actions, ...payload } = formData;
//     if (blankItem !== null) payload.items = items;
//     try {
//       let res;
//       if (selected) {
//         res = await api.patch(`${ep}${selected.id}/`, payload);
//       } else {
//         res = await api.post(ep, payload);
//       }
//       if (decreeFile && res.data?.id) {
//         const fd = new FormData();
//         fd.append("upload_copy_of_decree", decreeFile);
//         await api.patch(`${ep}${res.data.id}/`, fd, {
//           headers: { "Content-Type": "multipart/form-data" },
//         });
//       }
//       setSnack({ open: true, message: selected ? "Updated successfully" : "Saved as draft", severity: "success" });
//       fetchList();
//       setView("list");
//     } catch (e) {
//       setSnack({ open: true, message: JSON.stringify(e.response?.data) || "Save failed", severity: "error" });
//     } finally {
//       setSaving(false);
//     }
//   };

//   return {
//     view, setView, list, loading, formData, setFormData,
//     items, setItems, selected, saving, snack, setSnack,
//     decreeFile, setDecreeFile, fetchList, set,
//     handleFESelect, openNew, openEdit, openView, handleSave, refreshDetail,
//   };
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // LIST TABLE
// // ─────────────────────────────────────────────────────────────────────────────
// const ListTable = ({ title, columns, rows, loading, onNew, onView, onEdit, canAdd }) => {
//   const [filterFE, setFilterFE] = useState(null);

//   const filteredRows = filterFE
//     ? rows.filter((r) => r.fe === filterFE.id || r.fe_detail?.id === filterFE.id)
//     : [];

//   return (
//     <>
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h6" fontWeight="bold">{title}</Typography>
//         <Box sx={{ display: "flex", gap: 1 }}>
//           <Tooltip title="Refresh"><IconButton><Refresh /></IconButton></Tooltip>
//           {canAdd && (
//             <Button variant="contained" startIcon={<Add />} onClick={onNew}>New</Button>
//           )}
//         </Box>
//       </Box>

//       <Box sx={{ mb: 2, maxWidth: 400 }}>
//         <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
//           Select Financial Establishment to view records
//         </Typography>
//         <FEDropdown value={filterFE?.id || null} disabled={false} onSelect={(fe) => setFilterFE(fe || null)} />
//       </Box>

//       {!filterFE ? (
//         <Box sx={{ p: 4, textAlign: "center", border: "1px dashed #bbb", borderRadius: 2, background: "#fafafa" }}>
//           <Typography variant="body2" color="text.secondary">
//             Please select a Financial Establishment above to view records.
//           </Typography>
//         </Box>
//       ) : loading ? (
//         <Box display="flex" justifyContent="center" p={4}><LoadingSpinner size={30} /></Box>
//       ) : (
//         <TableComponent
//           columns={columns}
//           rows={filteredRows}
//           manageColumnStatus
//           enableSort
//           sx={{ "& .MuiDataGrid-columnHeaders": { backgroundColor: "#1976d2", color: "#fff", fontWeight: "bold" } }}
//         />
//       )}
//     </>
//   );
// };

// const commonCols = (onView, onEdit) => [
//   { id: "slNo",           field: "slNo",           headerName: "Sl No.",          width: 70  },
//   { id: "form_id",        field: "form_id",         headerName: "Form ID",         width: 180 },
//   { id: "fe_name",        field: "fe_name",         headerName: "FE",              width: 220 },
//   { id: "date_of_seizure",field: "date_of_seizure", headerName: "Date of Seizure", width: 140 },
//   { id: "office_type",    field: "office_type",     headerName: "Office",          width: 90  },
//   {
//     id: "statusLabel", field: "statusLabel", headerName: "Status", width: 200,
//     renderCell: (p) => <StatusChip status={p.row.status} />,
//   },
//   {
//     id: "actions", field: "actions", headerName: "Actions", width: 130,
//     renderCell: (p) => (
//       <Box sx={{ display: "flex", gap: 0.5 }}>
//         <Tooltip title="View">
//           <IconButton size="small" onClick={() => onView(p.row)}><Visibility fontSize="small" /></IconButton>
//         </Tooltip>
//         {EDITABLE.includes(p.row.status) && (
//           <Tooltip title="Edit">
//             <IconButton size="small" color="primary" onClick={() => onEdit(p.row)}><Edit fontSize="small" /></IconButton>
//           </Tooltip>
//         )}
//       </Box>
//     ),
//   },
// ];

// const toTableRows = (list) =>
//   list.map((item, i) => ({
//     ...item,
//     slNo:        i + 1,
//     statusLabel: STATUS_META[item.status]?.label || item.status,
//     fe_name:     item.fe_detail?.name_of_fe || "",
//   }));

// // ─────────────────────────────────────────────────────────────────────────────
// // MAIN COMPONENT
// // ─────────────────────────────────────────────────────────────────────────────
// export const AssetManagementComponent = () => {
//   const role   = useSelector((s) => s.auth.role);
//   const [tab, setTab] = useState(0);
//   const canAdd = ["super_staff"].includes(role);

//   const reg   = useFormManager("/legal/asset/register-seized-movable/", REG_BLANK, BLANK_ITEM);
//   const immov = useFormManager("/legal/asset/register-immovable/", IMMOV_BLANK, null);

//   const TABS = [
//     { label: "Register of Seized Movables" },
//     { label: "Register of Immovables"      },
//   ];

//   const renderTab = (mgr, formComp, listTitle, ep) => {
//     const tableRows = toTableRows(mgr.list);
//     const cols = commonCols(mgr.openView, mgr.openEdit);

//     return (
//       <Box>
//         {/* ── LIST ── */}
//         {mgr.view === "list" && (
//           <ListTable
//             title={listTitle} columns={cols} rows={tableRows}
//             loading={mgr.loading} onNew={mgr.openNew}
//             onView={mgr.openView} onEdit={mgr.openEdit} canAdd={canAdd}
//           />
//         )}

//         {/* ── CREATE / EDIT FORM ── */}
//         {mgr.view === "form" && (
//           <>
//             <Button size="small" onClick={() => mgr.setView("list")} sx={{ mb: 2 }}>← Back to List</Button>
//             {formComp}
//             <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
//               <Button variant="outlined" onClick={() => mgr.setView("list")}>Cancel</Button>
//               <Button variant="contained" onClick={mgr.handleSave} disabled={mgr.saving}
//                 startIcon={mgr.saving ? <CircularProgress size={16} /> : null}>
//                 {mgr.selected ? "Update" : "Save Draft"}
//               </Button>
//             </Box>
//           </>
//         )}

//         {/* ── DETAIL / APPROVAL VIEW ── */}
//         {mgr.view === "detail" && mgr.selected && (
//           <>
//             <Button size="small" onClick={() => mgr.setView("list")} sx={{ mb: 2 }}>← Back to List</Button>

//             {/* Status + flow info banner */}
//             <Box sx={{ mb: 2, display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
//               <StatusChip status={mgr.selected.status} />
//               <Chip
//                 size="small"
//                 label={mgr.selected.office_type === "rc"
//                   ? "RC Flow: Shirastedar → CA / RC (any order)"
//                   : "SPLOCA Flow: Shirastedar → Tahsildar / AC / JS / SPLOCA (any order)"}
//                 color="info"
//                 variant="outlined"
//               />
//             </Box>

//             {formComp}

//             {/* Approval trail (who approved so far) */}
//             <ApprovalTrail form={mgr.formData} />

//             {/* Actions available to this user */}
//             <ApprovalPanel
//               form={mgr.selected}
//               apiPath={ep}
//               onRefresh={mgr.refreshDetail}
//             />

//             <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
//               <Button variant="outlined" onClick={() => mgr.setView("list")}>Back to List</Button>
//               <Button variant="outlined" startIcon={<Print />} onClick={() => window.print()}>Print</Button>
//             </Box>
//           </>
//         )}

//         <SnackBarComponent
//           open={mgr.snack.open} message={mgr.snack.message} severity={mgr.snack.severity}
//           onClose={() => mgr.setSnack((s) => ({ ...s, open: false }))}
//         />
//       </Box>
//     );
//   };

//   return (
//     <Box sx={{ width: "100%", mt: 2, borderRadius: 2, boxShadow: "0 4px 12px rgba(0,0,0,0.08)", backgroundColor: "#fff" }}>
//       <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0", background: "rgba(25,118,210,0.04)" }}>
//         <Typography variant="h5" fontWeight="bold">
//           Asset Management — Seized Movables &amp; Immovables
//         </Typography>
//         <Typography variant="caption" color="text.secondary">
//           SPLOCA Flow: Shirastedar → then Tahsildar / AC / JS / SPLOCA can act in <strong>any order</strong>
//           &nbsp;|&nbsp;
//           RC Flow: Shirastedar → then CA / RC can act in <strong>any order</strong>
//           &nbsp;|&nbsp; SPLOCA / Admin can <strong>finalise directly</strong>
//         </Typography>
//       </Box>

//       <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ borderBottom: "1px solid #e0e0e0" }}>
//         {TABS.map((t, i) => <Tab key={i} label={t.label} />)}
//       </Tabs>

//       <Box sx={{ p: 3 }}>
//         {tab === 0 && renderTab(
//           reg,
//           <RegisterSeizedMovableForm
//             d={reg.formData} ro={reg.view === "detail"} set={reg.set}
//             items={reg.items} setItems={reg.setItems} onFESelect={reg.handleFESelect}
//           />,
//           "Register of Seized Movables",
//           "/legal/asset/register-seized-movable/",
//         )}

//         {tab === 1 && renderTab(
//           immov,
//           <RegisterImmovableForm
//             d={immov.formData} ro={immov.view === "detail"} set={immov.set}
//             onFESelect={immov.handleFESelect}
//             onFileChange={(f) => immov.setDecreeFile(f)}
//           />,
//           "Register of Immovables",
//           "/legal/asset/register-immovable/",
//         )}
//       </Box>
//     </Box>
//   );
// };



import React, { useState, useEffect, useCallback } from "react";
import {
  Box, Typography, Button, Tabs, Tab, TextField, Select, MenuItem,
  FormControl, IconButton, Tooltip, CircularProgress, Divider,
  Radio, RadioGroup, FormControlLabel, FormLabel, Chip, Alert,
} from "@mui/material";
import {
  Add, Delete, Edit, Visibility, Print, Refresh, OpenInNew,
  CheckCircle, Cancel, FlagCircle,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import api from "../../../../api/axiosInterceptor";
import { SnackBarComponent } from "../../../../Components/snackBar/snackBar";
import { LoadingSpinner } from "../../../../Components/spinner/spinner";
import TableComponent from "../../../../Components/TableComponent/TableComponent";
import FEDropdown from "../feDropdown";

// ─────────────────────────────────────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────────────────────────────────────
const TODAY = new Date().toISOString().split("T")[0];

const CATEGORY_OPTIONS = [
  "Computers & IT Peripherals", "HVAC", "Furniture & Fixtures",
  "Electrical Equipment", "Vehicles", "Machinery",
  "Jewellery & Valuables", "Cash & Cash Equivalents", "Office Equipment", "Other",
];

const CONDITION_OPTIONS = ["Serviceable", "Unused", "Damaged", "Scrap", "Under Repair"];

const IMMOV_CATEGORY_OPTIONS = [
  "Land", "Building", "Land & Building", "Agricultural Land",
  "Commercial Property", "Residential Property", "Industrial Property", "Other",
];

const IMMOV_SUBCATEGORY_OPTIONS = [
  "Plot", "Apartment", "Villa", "Office Space", "Warehouse", "Factory", "Farm Land", "Other",
];

const CONDITION_STATUS_OPTIONS = ["Good", "Average", "Poor", "Dilapidated"];

const STATUS_META = {
  draft:           { label: "Draft",                  color: "default" },
  submitted:       { label: "Submitted",              color: "primary" },
  approved_shira:  { label: "Approved (Shirastedar)", color: "success" },
  rejected_shira:  { label: "Rejected (Shirastedar)", color: "error"   },
  approved_tahsil: { label: "Approved (Tahsildar)",   color: "success" },
  rejected_tahsil: { label: "Rejected (Tahsildar)",   color: "error"   },
  approved_ac:     { label: "Approved (AC)",          color: "success" },
  rejected_ac:     { label: "Rejected (AC)",          color: "error"   },
  approved_js:     { label: "Approved (JS)",          color: "success" },
  rejected_js:     { label: "Rejected (JS)",          color: "error"   },
  approved_sploca: { label: "Approved (SPLOCA)",      color: "success" },
  rejected_sploca: { label: "Rejected (SPLOCA)",      color: "error"   },
  approved_ca:     { label: "Approved (CA)",          color: "success" },
  rejected_ca:     { label: "Rejected (CA)",          color: "error"   },
  approved_rc:     { label: "Approved (RC)",          color: "success" },
  rejected_rc:     { label: "Rejected (RC)",          color: "error"   },
  final:           { label: "Finalised",              color: "success" },
};

const StatusChip = ({ status }) => {
  const m = STATUS_META[status] || { label: status, color: "default" };
  return <Chip label={m.label} color={m.color} size="small" />;
};

const EDITABLE = [
  "draft", "rejected_shira", "rejected_tahsil", "rejected_ac",
  "rejected_js", "rejected_sploca", "rejected_ca", "rejected_rc",
];

// ─────────────────────────────────────────────────────────────────────────────
// SHARED HELPERS
// ─────────────────────────────────────────────────────────────────────────────
const TF = ({ label, value, onChange, type = "text", disabled, multiline, rows, sx = {} }) => (
  <TextField
    label={label}
    value={value ?? ""}
    size="small"
    fullWidth
    type={type}
    disabled={disabled}
    multiline={multiline}
    rows={rows}
    InputLabelProps={type === "date" ? { shrink: true } : undefined}
    onChange={onChange ? (e) => onChange(e.target.value) : undefined}
    sx={sx}
  />
);

const FG = ({ children, cols = 3, sx = {} }) => (
  <Box sx={{ display: "grid", gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 2, mb: 2, ...sx }}>
    {children}
  </Box>
);

const SecHead = ({ label }) => (
  <Box sx={{ background: "#1976d2", color: "#fff", px: 2, py: 1, borderRadius: 1, mb: 1 }}>
    <Typography variant="body2" fontWeight="bold">{label}</Typography>
  </Box>
);

// ─────────────────────────────────────────────────────────────────────────────
// FORM HEADER
// ─────────────────────────────────────────────────────────────────────────────
const FormHeader = ({ d, ro, set, onFESelect, showFormId = false }) => (
  <Box>
    {showFormId && d.form_id && (
      <Box sx={{ mb: 2, p: 1.5, background: "#e3f2fd", borderRadius: 1, display: "flex", gap: 2, alignItems: "center" }}>
        <Typography variant="body2" fontWeight="bold" color="primary">Form ID:</Typography>
        <Typography variant="body1" fontWeight="bold">{d.form_id}</Typography>
      </Box>
    )}

    {!ro && (
      <Box sx={{ mb: 2 }}>
        <FormControl>
          <FormLabel><Typography variant="body2" fontWeight="bold">Office Type</Typography></FormLabel>
          <RadioGroup row value={d.office_type || "sploca"} onChange={(e) => set("office_type", e.target.value)}>
            <FormControlLabel value="sploca" control={<Radio size="small" />} label="SPLOCA" />
            <FormControlLabel value="rc"     control={<Radio size="small" />} label="RC" />
          </RadioGroup>
        </FormControl>
      </Box>
    )}
    {ro && d.office_type && (
      <Box sx={{ mb: 1 }}>
        <Typography variant="caption" color="text.secondary">Office Type: </Typography>
        <Chip label={d.office_type?.toUpperCase()} size="small" color="info" sx={{ ml: 0.5 }} />
      </Box>
    )}

    <FG cols={3}>
      <Box>
        <Typography variant="caption" sx={{ color: "#d32f2f" }}>Financial Establishment *</Typography>
        {ro ? (
          <Typography variant="body2" fontWeight="bold">{d.fe_detail?.name_of_fe || ""}</Typography>
        ) : (
          <FEDropdown value={d.fe} disabled={false} onSelect={(fe) => onFESelect && onFESelect(fe)} />
        )}
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary">Seized Stores of</Typography>
        <TF value={d.seized_stores_of} disabled={ro} onChange={ro ? null : (v) => set("seized_stores_of", v)} />
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary">Date of Seizure</Typography>
        <TF type="date" value={d.date_of_seizure} disabled={ro} onChange={ro ? null : (v) => set("date_of_seizure", v)} />
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary">Date of Handover</Typography>
        <TF type="date" value={d.date_of_handover} disabled={ro} onChange={ro ? null : (v) => set("date_of_handover", v)} />
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary">Handover By</Typography>
        <TF value={d.handover_by} disabled={ro} onChange={ro ? null : (v) => set("handover_by", v)} />
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary">Takeover By CA</Typography>
        <TF value={d.takeover_by_ca} disabled={ro} onChange={ro ? null : (v) => set("takeover_by_ca", v)} />
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary">Location of Store</Typography>
        <TF value={d.location_of_store} disabled={ro} onChange={ro ? null : (v) => set("location_of_store", v)} />
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary">Seized Stores Officer</Typography>
        <TF value={d.seized_stores_officer} disabled={ro} onChange={ro ? null : (v) => set("seized_stores_officer", v)} />
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary">Date of Sanction by Court</Typography>
        <TF type="date" value={d.date_of_sanction_by_court} disabled={ro} onChange={ro ? null : (v) => set("date_of_sanction_by_court", v)} />
      </Box>
    </FG>
  </Box>
);

// ─────────────────────────────────────────────────────────────────────────────
// APPROVAL TRAIL
// ─────────────────────────────────────────────────────────────────────────────
const TRAIL_FIELDS = [
  { key: "shirastedar", label: "Shirastedar" },
  { key: "tahsildar",   label: "Tahsildar"   },
  { key: "ac",          label: "AC"          },
  { key: "js",          label: "JS"          },
  { key: "sploca",      label: "SPLOCA"      },
  { key: "ca",          label: "CA"          },
  { key: "rc",          label: "RC"          },
];

const ApprovalTrail = ({ form }) => {
  const entries = TRAIL_FIELDS.filter(
    (f) => form[`${f.key}_by`] || form[`${f.key}_at`] || form[`${f.key}_remarks`]
  );
  if (!entries.length) return null;

  return (
    <Box sx={{ mt: 2, mb: 1 }}>
      <Typography variant="subtitle2" fontWeight="bold" mb={1} color="text.secondary">
        Approval Trail
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {entries.map((f) => (
          <Box key={f.key} sx={{ display: "flex", gap: 2, p: 1.5, background: "#f5f5f5", borderRadius: 1, alignItems: "flex-start" }}>
            <Box sx={{ minWidth: 100 }}>
              <Typography variant="caption" fontWeight="bold" color="text.secondary">{f.label}</Typography>
            </Box>
            <Box sx={{ flex: 1 }}>
              {form[`${f.key}_by`] && (
                <Typography variant="caption" display="block">
                  By: <strong>{form[`${f.key}_by`]}</strong>
                </Typography>
              )}
              {form[`${f.key}_at`] && (
                <Typography variant="caption" display="block" color="text.secondary">
                  At: {new Date(form[`${f.key}_at`]).toLocaleString()}
                </Typography>
              )}
              {form[`${f.key}_remarks`] && (
                <Typography variant="caption" display="block" sx={{ mt: 0.5, color: "#555", fontStyle: "italic" }}>
                  Remarks: {form[`${f.key}_remarks`]}
                </Typography>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// APPROVAL PANEL  ← role prop added, sent in action POST
// ─────────────────────────────────────────────────────────────────────────────
const ApprovalPanel = ({ form, apiPath, onRefresh, role }) => {
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);
  const [snack, setSnack]     = useState({ open: false, message: "", severity: "info" });

  const available = form?.available_actions || [];

  const doAction = async (action) => {
    setLoading(true);
    try {
      // FIX: send role in the POST body so the action endpoint
      // uses the same role resolution as the detail GET
      await api.post(`${apiPath}${form.id}/action/`, { action, remarks, role });
      setSnack({ open: true, message: "Action completed successfully", severity: "success" });
      onRefresh();
    } catch (e) {
      setSnack({ open: true, message: e.response?.data?.error || "Action failed", severity: "error" });
    } finally {
      setLoading(false);
    }
  };

  const getIcon = (color) => {
    if (color === "success") return <CheckCircle fontSize="small" />;
    if (color === "error")   return <Cancel fontSize="small" />;
    return <FlagCircle fontSize="small" />;
  };

  if (form?.status === "final") {
    return (
      <Box sx={{ mt: 3, p: 2, border: "1px solid #c8e6c9", borderRadius: 2, background: "#f1f8e9" }}>
        <Typography variant="subtitle2" color="success.main" fontWeight="bold">
          ✓ This form has been finalised
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 2, background: "#f5f5f5" }}>
      <Typography variant="subtitle2" fontWeight="bold" mb={1}>Available Actions</Typography>

      {available.length === 0 ? (
        <Alert severity="info" sx={{ mt: 1 }}>
          No actions available for your role at this stage.
        </Alert>
      ) : (
        <>
          <Box sx={{ mb: 2, p: 1.5, background: "#fff3e0", borderRadius: 1, border: "1px solid #ffe0b2" }}>
            <Typography variant="caption" color="text.secondary">
              <strong>Flexible flow:</strong> Actions below are available to your role at this stage.
            </Typography>
          </Box>
          <TextField
            fullWidth size="small" label="Remarks (optional)"
            value={remarks} onChange={(e) => setRemarks(e.target.value)}
            multiline rows={2} sx={{ mb: 2, background: "#fff" }}
          />
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {available.map((a) => (
              <Button
                key={a.action}
                variant="contained"
                color={a.color}
                size="small"
                disabled={loading}
                onClick={() => doAction(a.action)}
                startIcon={loading ? <CircularProgress size={14} /> : getIcon(a.color)}
              >
                {a.label}
              </Button>
            ))}
          </Box>
        </>
      )}

      <SnackBarComponent
        open={snack.open} message={snack.message} severity={snack.severity}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
      />
    </Box>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MOVABLE ITEM EDITOR
// ─────────────────────────────────────────────────────────────────────────────
const BLANK_ITEM = {
  category_type: "", item_name: "", description: "", material: "",
  quantity: "", weight: "", brand: "", model_no: "", make: "",
  condition: "", condition_detail: "",
  stored_in_area_no: "", room_no: "", floor: "", address: "",
  assigned_sold_to: "", assigned_date: "", release_to: "", release_date: "",
  unit_price: "", book_value: "", estimated_value_auction: "",
  obsolescence_percentage: "", total_reserve_price: "",
  floor_price: "", depreciation_percentage: "",
};

const MovableItemEditor = ({ item, idx, ro, onChange }) => {
  const s = (f, v) => onChange(idx, f, v);

  return (
    <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2, mb: 2, background: idx % 2 === 0 ? "#fafafa" : "#fff" }}>
      <Box sx={{ background: "#1976d2", color: "#fff", px: 2, py: 0.5, borderRadius: 1, mb: 2 }}>
        <Typography variant="body2" fontWeight="bold">{idx + 1}</Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="caption" color="text.secondary">Category & Type</Typography>
        {ro ? (
          <Typography variant="body2">{item.category_type}</Typography>
        ) : (
          <FormControl size="small" fullWidth>
            <Select value={item.category_type || ""} displayEmpty onChange={(e) => s("category_type", e.target.value)}>
              <MenuItem value=""><em>Select Category</em></MenuItem>
              {CATEGORY_OPTIONS.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
            </Select>
          </FormControl>
        )}
      </Box>

      <FG cols={3}>
        <Box>
          <Typography variant="caption" color="text.secondary">Item Name</Typography>
          <TF value={item.item_name} disabled={ro} onChange={ro ? null : (v) => s("item_name", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Description</Typography>
          <TF value={item.description} disabled={ro} multiline rows={2} onChange={ro ? null : (v) => s("description", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Material</Typography>
          <TF value={item.material} disabled={ro} onChange={ro ? null : (v) => s("material", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Quantity</Typography>
          <TF value={item.quantity} disabled={ro} onChange={ro ? null : (v) => s("quantity", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Weight</Typography>
          <TF value={item.weight} disabled={ro} onChange={ro ? null : (v) => s("weight", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Brand</Typography>
          <TF value={item.brand} disabled={ro} onChange={ro ? null : (v) => s("brand", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Model</Typography>
          <TF value={item.model_no} disabled={ro} onChange={ro ? null : (v) => s("model_no", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Make</Typography>
          <TF value={item.make} disabled={ro} onChange={ro ? null : (v) => s("make", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Condition</Typography>
          {ro ? (
            <Typography variant="body2">{item.condition}</Typography>
          ) : (
            <FormControl size="small" fullWidth>
              <Select value={item.condition || ""} displayEmpty onChange={(e) => s("condition", e.target.value)}>
                <MenuItem value=""><em>Select</em></MenuItem>
                {CONDITION_OPTIONS.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
              </Select>
            </FormControl>
          )}
        </Box>
        <Box sx={{ gridColumn: "span 2" }}>
          <Typography variant="caption" color="text.secondary">Condition Detail</Typography>
          <TF value={item.condition_detail} disabled={ro} onChange={ro ? null : (v) => s("condition_detail", v)} />
        </Box>
      </FG>

      {/* Valuation */}
      <Box sx={{ border: "2px solid #f44336", borderRadius: 2, p: 2, mt: 1, mb: 2 }}>
        <Typography variant="caption" fontWeight="bold" color="error" display="block" mb={1}>
          Valuation Details
        </Typography>
        <FG cols={2}>
          {[
            { f: "unit_price",              l: "Unit Price"                        },
            { f: "book_value",              l: "Book Value"                        },
            { f: "estimated_value_auction", l: "Estimated Value (Year of Auction)" },
            { f: "obsolescence_percentage", l: "Obsolescence Percentage"           },
            { f: "total_reserve_price",     l: "Total Reserve Price"               },
            { f: "floor_price",             l: "Floor Price"                       },
            { f: "depreciation_percentage", l: "Depreciation Percentage"           },
          ].map(({ f, l }) => (
            <Box key={f}>
              <Typography variant="caption" color="text.secondary">{l}</Typography>
              <TF type="number" value={item[f]} disabled={ro} onChange={ro ? null : (v) => s(f, v)} />
            </Box>
          ))}
        </FG>
      </Box>

      {/* Storage Details */}
      <Divider sx={{ my: 1 }} />
      <Typography variant="caption" fontWeight="bold" color="primary" display="block" mb={1}>
        Storage Details
      </Typography>
      <FG cols={2}>
        {[
          { f: "stored_in_area_no", l: "Stored in Area No" },
          { f: "room_no",           l: "Room No"           },
          { f: "floor",             l: "Floor"             },
        ].map(({ f, l }) => (
          <Box key={f}>
            <Typography variant="caption" color="text.secondary">{l}</Typography>
            <TF value={item[f]} disabled={ro} onChange={ro ? null : (v) => s(f, v)} />
          </Box>
        ))}
        <Box>
          <Typography variant="caption" color="text.secondary">Address</Typography>
          <TF value={item.address} disabled={ro} multiline rows={2} onChange={ro ? null : (v) => s("address", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Assigned / Sold To</Typography>
          <TF value={item.assigned_sold_to} disabled={ro} onChange={ro ? null : (v) => s("assigned_sold_to", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Assigned Date</Typography>
          <TF type="date" value={item.assigned_date} disabled={ro} onChange={ro ? null : (v) => s("assigned_date", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Release To</Typography>
          <TF value={item.release_to} disabled={ro} onChange={ro ? null : (v) => s("release_to", v)} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Release Date</Typography>
          <TF type="date" value={item.release_date} disabled={ro} onChange={ro ? null : (v) => s("release_date", v)} />
        </Box>
      </FG>

      {!ro && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
          <Button size="small" color="error" startIcon={<Delete />}
            onClick={() => onChange(idx, "__DELETE__", null)}>
            Remove Item
          </Button>
        </Box>
      )}
    </Box>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// REGISTER OF SEIZED MOVABLES FORM
// ─────────────────────────────────────────────────────────────────────────────
const REG_BLANK = {
  fe: null, fe_detail: null, office_type: "sploca",
  seized_stores_of: "", date_of_seizure: "", date_of_handover: "",
  handover_by: "", takeover_by_ca: "", location_of_store: "",
  seized_stores_officer: "", date_of_sanction_by_court: "",
  date: TODAY, recipient_name: "",
};

const RegisterSeizedMovableForm = ({ d, ro, set, items, setItems, onFESelect }) => (
  <Box>
    <FormHeader d={d} ro={ro} set={set} onFESelect={onFESelect} showFormId />
    <SecHead label="Sl.No — Items" />
    {items.map((item, idx) => (
      <MovableItemEditor
        key={idx} item={item} idx={idx} ro={ro}
        onChange={(i, f, v) => {
          if (f === "__DELETE__") { setItems((it) => it.filter((_, ri) => ri !== i)); return; }
          setItems((it) => it.map((rw, ri) => (ri === i ? { ...rw, [f]: v } : rw)));
        }}
      />
    ))}
    {!ro && (
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button variant="outlined" startIcon={<Add />} size="small"
          onClick={() => setItems((it) => [...it, { ...BLANK_ITEM }])}>
          Add Item
        </Button>
      </Box>
    )}
    <FG cols={2}>
      <Box>
        <Typography variant="caption" color="text.secondary">Date</Typography>
        <TF type="date" value={d.date} disabled={ro} onChange={ro ? null : (v) => set("date", v)} />
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary">Recipient Name</Typography>
        <TF value={d.recipient_name} disabled={ro} onChange={ro ? null : (v) => set("recipient_name", v)} />
      </Box>
    </FG>
  </Box>
);

// ─────────────────────────────────────────────────────────────────────────────
// REGISTER OF IMMOVABLES FORM
// ─────────────────────────────────────────────────────────────────────────────
const IMMOV_BLANK = {
  fe: null, fe_detail: null, office_type: "sploca",
  seized_stores_of: "", date_of_seizure: "", date_of_handover: "",
  handover_by: "", takeover_by_ca: "", location_of_store: "",
  seized_stores_officer: "", date_of_sanction_by_court: "",
  asset_categorization: "", asset_sub_categorization: "",
  name: "", description: "", category: "", date_of_acquisition: "",
  quantity: "", unit_book_value: "", total_book_value: "",
  location: "", police_station: "", police_station_contact: "",
  tahsildar: "", tahsildar_contact: "",
  depreciation_appreciation: "", npv_calculation: "", condition: "",
  reserve_price: "", litigation_any_forum: "", case_number_in_court: "",
  court_or_forum_name: "", details_of_decree: "", case_status: "Final",
  brief_description_decree: "", road_approach: "", schedule: "",
  marked_values: "", reason_for_present_marked_values: "",
};

const RegisterImmovableForm = ({ d, ro, set, onFESelect, onFileChange }) => (
  <Box>
    <FormHeader d={d} ro={ro} set={set} onFESelect={onFESelect} showFormId />

    <SecHead label="1 — Asset Categorization" />
    <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 1, p: 2, mb: 2 }}>

      {/* Asset Categorization */}
      <Box sx={{ display: "grid", gridTemplateColumns: "60px 200px 1fr", gap: 1, mb: 1, py: 1, borderBottom: "1px solid #eee", alignItems: "center" }}>
        <Typography variant="body2">1</Typography>
        <Typography variant="body2">Asset Categorization</Typography>
        {ro ? (
          <Typography variant="body2">{d.asset_categorization}</Typography>
        ) : (
          <FormControl size="small" fullWidth>
            <Select value={d.asset_categorization || ""} displayEmpty onChange={(e) => set("asset_categorization", e.target.value)}>
              <MenuItem value=""><em>Select</em></MenuItem>
              {IMMOV_CATEGORY_OPTIONS.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
            </Select>
          </FormControl>
        )}
      </Box>

      {/* Sub-Categorization */}
      <Box sx={{ display: "grid", gridTemplateColumns: "60px 200px 1fr", gap: 1, mb: 1, py: 1, borderBottom: "1px solid #eee", alignItems: "center" }}>
        <Typography variant="body2">3</Typography>
        <Typography variant="body2">Immovable Sub-Categorization</Typography>
        {ro ? (
          <Typography variant="body2">{d.asset_sub_categorization}</Typography>
        ) : (
          <FormControl size="small" fullWidth>
            <Select value={d.asset_sub_categorization || ""} displayEmpty onChange={(e) => set("asset_sub_categorization", e.target.value)}>
              <MenuItem value=""><em>Select Sub-Categorization</em></MenuItem>
              {IMMOV_SUBCATEGORY_OPTIONS.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
            </Select>
          </FormControl>
        )}
      </Box>

      {/* Immovable Asset Details */}
      <Box sx={{ display: "grid", gridTemplateColumns: "60px 200px 1fr", gap: 1, alignItems: "flex-start", py: 1 }}>
        <Typography variant="body2">4</Typography>
        <Typography variant="body2">Immovable Asset Details &amp; Status</Typography>
        <Box>
          {[
            { f: "name",     l: "Name"     },
            { f: "category", l: "Category" },
          ].map(({ f, l }) => (
            <Box key={f} sx={{ mb: 1 }}>
              <Typography variant="caption" color="text.secondary">{l}</Typography>
              <TF value={d[f]} disabled={ro} onChange={ro ? null : (v) => set(f, v)} />
            </Box>
          ))}
          <Box sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary">Description</Typography>
            <TF value={d.description} disabled={ro} multiline rows={3} onChange={ro ? null : (v) => set("description", v)} />
          </Box>
          <FG cols={2} sx={{ mb: 1 }}>
            <Box>
              <Typography variant="caption" color="text.secondary">Date of Acquisition</Typography>
              <TF type="date" value={d.date_of_acquisition} disabled={ro} onChange={ro ? null : (v) => set("date_of_acquisition", v)} />
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">Quantity</Typography>
              <TF value={d.quantity} disabled={ro} onChange={ro ? null : (v) => set("quantity", v)} />
            </Box>
          </FG>
          <FG cols={2} sx={{ mb: 1 }}>
            <Box>
              <Typography variant="caption" color="text.secondary">Unit Book Value</Typography>
              <TF type="number" value={d.unit_book_value} disabled={ro} onChange={ro ? null : (v) => set("unit_book_value", v)} />
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">Total Book Value</Typography>
              <TF type="number" value={d.total_book_value} disabled={ro} onChange={ro ? null : (v) => set("total_book_value", v)} />
            </Box>
          </FG>
          <Box sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary">Location</Typography>
            <TF value={d.location} disabled={ro} multiline rows={2} onChange={ro ? null : (v) => set("location", v)} />
          </Box>
          <FG cols={2} sx={{ mb: 1 }}>
            <Box>
              <Typography variant="caption" color="text.secondary">Police Station</Typography>
              <TF value={d.police_station} disabled={ro} onChange={ro ? null : (v) => set("police_station", v)} />
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">Police Station Contact</Typography>
              <TF value={d.police_station_contact} disabled={ro} onChange={ro ? null : (v) => set("police_station_contact", v)} />
            </Box>
          </FG>
          <FG cols={2} sx={{ mb: 1 }}>
            <Box>
              <Typography variant="caption" color="text.secondary">Tahsildar</Typography>
              <TF value={d.tahsildar} disabled={ro} onChange={ro ? null : (v) => set("tahsildar", v)} />
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">Tahsildar Contact</Typography>
              <TF value={d.tahsildar_contact} disabled={ro} onChange={ro ? null : (v) => set("tahsildar_contact", v)} />
            </Box>
          </FG>
          <FG cols={2} sx={{ mb: 1 }}>
            <Box>
              <Typography variant="caption" color="text.secondary">Depreciation / Appreciation</Typography>
              <TF type="number" value={d.depreciation_appreciation} disabled={ro} onChange={ro ? null : (v) => set("depreciation_appreciation", v)} />
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">NPV Calculation</Typography>
              <TF type="number" value={d.npv_calculation} disabled={ro} onChange={ro ? null : (v) => set("npv_calculation", v)} />
            </Box>
          </FG>
          <Box sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary">Condition</Typography>
            {ro ? (
              <Typography variant="body2">{d.condition}</Typography>
            ) : (
              <FormControl size="small" fullWidth>
                <Select value={d.condition || ""} displayEmpty onChange={(e) => set("condition", e.target.value)}>
                  <MenuItem value=""><em>-Select-</em></MenuItem>
                  {CONDITION_STATUS_OPTIONS.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
                </Select>
              </FormControl>
            )}
          </Box>
          <Box sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary">Reserve Price</Typography>
            <TF type="number" value={d.reserve_price} disabled={ro} onChange={ro ? null : (v) => set("reserve_price", v)} />
          </Box>

          <Typography variant="body2" fontWeight="bold" sx={{ mt: 2, mb: 1 }}>Court Cases if any</Typography>
          {[
            { f: "litigation_any_forum", l: "Litigation in Any Forum" },
            { f: "case_number_in_court", l: "Case Number in Court"   },
            { f: "court_or_forum_name",  l: "Court Or Forum Name"    },
          ].map(({ f, l }) => (
            <Box key={f} sx={{ mb: 1 }}>
              <Typography variant="caption" color="text.secondary">{l}</Typography>
              <TF value={d[f]} disabled={ro} onChange={ro ? null : (v) => set(f, v)} />
            </Box>
          ))}
          <Box sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary">Details of any Decree</Typography>
            <TF value={d.details_of_decree} disabled={ro} multiline rows={3} onChange={ro ? null : (v) => set("details_of_decree", v)} />
          </Box>
          <Box sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary">Status</Typography>
            {ro ? (
              <Typography variant="body2">{d.case_status}</Typography>
            ) : (
              <FormControl size="small" fullWidth>
                <Select value={d.case_status || "Final"} onChange={(e) => set("case_status", e.target.value)}>
                  {["Final", "Pending", "Disposed"].map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
                </Select>
              </FormControl>
            )}
          </Box>
          <Box sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary">Brief Description of Decree</Typography>
            <TF value={d.brief_description_decree} disabled={ro} multiline rows={2}
              onChange={ro ? null : (v) => set("brief_description_decree", v)} />
          </Box>

          {!ro ? (
            <Box sx={{ mb: 1 }}>
              <Typography variant="caption" color="text.secondary">Upload copy of Decree</Typography>
              <Box sx={{ mt: 0.5 }}>
                <input type="file" accept=".pdf,.jpg,.jpeg,.png"
                  onChange={(e) => onFileChange && onFileChange(e.target.files[0])} />
              </Box>
            </Box>
          ) : (
            d.upload_copy_of_decree && (
              <Box sx={{ mb: 1 }}>
                <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>Copy of Decree</Typography>
                <Button variant="outlined" size="small" startIcon={<OpenInNew fontSize="small" />}
                  onClick={() => window.open(d.upload_copy_of_decree, "_blank")}>
                  View Decree Document
                </Button>
              </Box>
            )
          )}
        </Box>
      </Box>

      {/* Guidelines values */}
      <Box sx={{ display: "grid", gridTemplateColumns: "60px 200px 1fr", gap: 1, py: 1, borderTop: "1px solid #eee", alignItems: "flex-start" }}>
        <Typography variant="body2">6</Typography>
        <Typography variant="body2">Immovable</Typography>
        <Box>
          <Typography variant="caption" color="text.secondary" display="block" mb={1}>Guidelines values</Typography>
          <FG cols={2}>
            <Box>
              <Typography variant="caption" color="text.secondary">Road Approach</Typography>
              {ro ? (
                <Typography variant="body2">{d.road_approach}</Typography>
              ) : (
                <FormControl size="small" fullWidth>
                  <Select value={d.road_approach || ""} displayEmpty onChange={(e) => set("road_approach", e.target.value)}>
                    <MenuItem value=""><em>Select</em></MenuItem>
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </FormControl>
              )}
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">Schedule</Typography>
              {ro ? (
                <Typography variant="body2">{d.schedule}</Typography>
              ) : (
                <FormControl size="small" fullWidth>
                  <Select value={d.schedule || ""} displayEmpty onChange={(e) => set("schedule", e.target.value)}>
                    <MenuItem value=""><em>Select</em></MenuItem>
                    {["I", "II", "III", "IV", "V"].map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
                  </Select>
                </FormControl>
              )}
            </Box>
          </FG>
          <Box sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary">Marked values</Typography>
            <TF value={d.marked_values} disabled={ro} onChange={ro ? null : (v) => set("marked_values", v)} />
          </Box>
          <Box>
            <Typography variant="caption" sx={{ color: "#f57c00" }}>Reason for fixing present marked values</Typography>
            <TF value={d.reason_for_present_marked_values} disabled={ro} multiline rows={3}
              onChange={ro ? null : (v) => set("reason_for_present_marked_values", v)} />
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);

// ─────────────────────────────────────────────────────────────────────────────
// GENERIC FORM MANAGEMENT HOOK
// ─────────────────────────────────────────────────────────────────────────────
const useFormManager = (ep, blank, blankItem = null, role = null) => {
  const [view, setView]         = useState("list");
  const [list, setList]         = useState([]);
  const [loading, setLoading]   = useState(false);
  const [formData, setFormData] = useState({ ...blank });
  const [items, setItems]       = useState(blankItem ? [{ ...blankItem }] : []);
  const [selected, setSelected] = useState(null);
  const [saving, setSaving]     = useState(false);
  const [snack, setSnack]       = useState({ open: false, message: "", severity: "info" });
  const [decreeFile, setDecreeFile] = useState(null);

  const fetchList = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get(ep);
      setList(r.data);
    } catch {
      setSnack({ open: true, message: "Failed to load", severity: "error" });
    } finally {
      setLoading(false);
    }
  }, [ep]);

  useEffect(() => { fetchList(); }, [fetchList]);

  const set = (f, v) => setFormData((d) => ({ ...d, [f]: v }));

  const handleFESelect = (fe) => {
    if (!fe) return;
    setFormData((d) => ({ ...d, fe: fe.id, fe_detail: fe }));
  };

  const openNew = () => {
    setFormData({ ...blank });
    setItems(blankItem ? [{ ...blankItem }] : []);
    setSelected(null);
    setDecreeFile(null);
    setView("form");
  };

  const openEdit = (item) => {
    setFormData({ ...item });
    setItems(item.items || []);
    setSelected(item);
    setDecreeFile(null);
    setView("form");
  };

  const openView = async (item) => {
    try {
      const r = await api.get(`${ep}${item.id}/`, { params: { role } });
      setFormData(r.data);
      setItems(r.data.items || []);
      setSelected(r.data);
    } catch {
      setFormData(item);
      setItems(item.items || []);
      setSelected(item);
    }
    setView("detail");
  };

  const refreshDetail = async () => {
    if (!selected?.id) return;
    try {
      const r = await api.get(`${ep}${selected.id}/`, { params: { role } });
      setFormData(r.data);
      setItems(r.data.items || []);
      setSelected(r.data);
    } catch {/* ignore */}
  };

  const handleSave = async () => {
    setSaving(true);
    const { fe_detail, available_actions, ...payload } = formData;
    if (blankItem !== null) payload.items = items;
    try {
      let res;
      if (selected) {
        res = await api.patch(`${ep}${selected.id}/`, payload);
      } else {
        res = await api.post(ep, payload);
      }
      if (decreeFile && res.data?.id) {
        const fd = new FormData();
        fd.append("upload_copy_of_decree", decreeFile);
        await api.patch(`${ep}${res.data.id}/`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }
      setSnack({ open: true, message: selected ? "Updated successfully" : "Saved as draft", severity: "success" });
      fetchList();
      setView("list");
    } catch (e) {
      setSnack({ open: true, message: JSON.stringify(e.response?.data) || "Save failed", severity: "error" });
    } finally {
      setSaving(false);
    }
  };

  return {
    view, setView, list, loading, formData, setFormData,
    items, setItems, selected, saving, snack, setSnack,
    decreeFile, setDecreeFile, fetchList, set,
    handleFESelect, openNew, openEdit, openView, handleSave, refreshDetail,
  };
};

// ─────────────────────────────────────────────────────────────────────────────
// LIST TABLE
// ─────────────────────────────────────────────────────────────────────────────
const ListTable = ({ title, columns, rows, loading, onNew, onView, onEdit, canAdd }) => {
  const [filterFE, setFilterFE] = useState(null);

  const filteredRows = filterFE
    ? rows.filter((r) => r.fe === filterFE.id || r.fe_detail?.id === filterFE.id)
    : [];

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight="bold">{title}</Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Tooltip title="Refresh"><IconButton><Refresh /></IconButton></Tooltip>
          {canAdd && (
            <Button variant="contained" startIcon={<Add />} onClick={onNew}>New</Button>
          )}
        </Box>
      </Box>

      <Box sx={{ mb: 2, maxWidth: 400 }}>
        <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
          Select Financial Establishment to view records
        </Typography>
        <FEDropdown value={filterFE?.id || null} disabled={false} onSelect={(fe) => setFilterFE(fe || null)} />
      </Box>

      {!filterFE ? (
        <Box sx={{ p: 4, textAlign: "center", border: "1px dashed #bbb", borderRadius: 2, background: "#fafafa" }}>
          <Typography variant="body2" color="text.secondary">
            Please select a Financial Establishment above to view records.
          </Typography>
        </Box>
      ) : loading ? (
        <Box display="flex" justifyContent="center" p={4}><LoadingSpinner size={30} /></Box>
      ) : (
        <TableComponent
          columns={columns}
          rows={filteredRows}
          manageColumnStatus
          enableSort
          sx={{ "& .MuiDataGrid-columnHeaders": { backgroundColor: "#1976d2", color: "#fff", fontWeight: "bold" } }}
        />
      )}
    </>
  );
};

const commonCols = (onView, onEdit) => [
  { id: "slNo",            field: "slNo",           headerName: "Sl No.",          width: 70  },
  { id: "form_id",         field: "form_id",         headerName: "Form ID",         width: 180 },
  { id: "fe_name",         field: "fe_name",         headerName: "FE",              width: 220 },
  { id: "date_of_seizure", field: "date_of_seizure", headerName: "Date of Seizure", width: 140 },
  { id: "office_type",     field: "office_type",     headerName: "Office",          width: 90  },
  {
    id: "statusLabel", field: "statusLabel", headerName: "Status", width: 200,
    renderCell: (p) => <StatusChip status={p.row.status} />,
  },
  {
    id: "actions", field: "actions", headerName: "Actions", width: 130,
    renderCell: (p) => (
      <Box sx={{ display: "flex", gap: 0.5 }}>
        <Tooltip title="View">
          <IconButton size="small" onClick={() => onView(p.row)}><Visibility fontSize="small" /></IconButton>
        </Tooltip>
        {EDITABLE.includes(p.row.status) && (
          <Tooltip title="Edit">
            <IconButton size="small" color="primary" onClick={() => onEdit(p.row)}><Edit fontSize="small" /></IconButton>
          </Tooltip>
        )}
      </Box>
    ),
  },
];

const toTableRows = (list) =>
  list.map((item, i) => ({
    ...item,
    slNo:        i + 1,
    statusLabel: STATUS_META[item.status]?.label || item.status,
    fe_name:     item.fe_detail?.name_of_fe || "",
  }));

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
export const AssetManagementComponent = () => {
  // FIX: normalize role — signin API returns ["super_staff"] (array), extract string
  const rawRole = useSelector((s) => s.auth.role);
  const role    = Array.isArray(rawRole) ? rawRole[0] : rawRole;

  const [tab, setTab] = useState(0);
  const canAdd = ["super_staff"].includes(role);

  const reg   = useFormManager("/legal/asset/register-seized-movable/", REG_BLANK, BLANK_ITEM, role);
  const immov = useFormManager("/legal/asset/register-immovable/", IMMOV_BLANK, null, role);

  const TABS = [
    { label: "Register of Seized Movables" },
    { label: "Register of Immovables"      },
  ];

  const renderTab = (mgr, formComp, listTitle, ep) => {
    const tableRows = toTableRows(mgr.list);
    const cols      = commonCols(mgr.openView, mgr.openEdit);

    return (
      <Box>
        {mgr.view === "list" && (
          <ListTable
            title={listTitle} columns={cols} rows={tableRows}
            loading={mgr.loading} onNew={mgr.openNew}
            onView={mgr.openView} onEdit={mgr.openEdit} canAdd={canAdd}
          />
        )}

        {mgr.view === "form" && (
          <>
            <Button size="small" onClick={() => mgr.setView("list")} sx={{ mb: 2 }}>← Back to List</Button>
            {formComp}
            <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
              <Button variant="outlined" onClick={() => mgr.setView("list")}>Cancel</Button>
              <Button variant="contained" onClick={mgr.handleSave} disabled={mgr.saving}
                startIcon={mgr.saving ? <CircularProgress size={16} /> : null}>
                {mgr.selected ? "Update" : "Save Draft"}
              </Button>
            </Box>
          </>
        )}

        {mgr.view === "detail" && mgr.selected && (
          <>
            <Button size="small" onClick={() => mgr.setView("list")} sx={{ mb: 2 }}>← Back to List</Button>

            <Box sx={{ mb: 2, display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
              <StatusChip status={mgr.selected.status} />
              <Chip
                size="small"
                label={mgr.selected.office_type === "rc"
                  ? "RC Flow: Shirastedar → CA / RC (any order)"
                  : "SPLOCA Flow: Shirastedar → Tahsildar / AC / JS / SPLOCA (any order)"}
                color="info"
                variant="outlined"
              />
            </Box>

            {formComp}

            <ApprovalTrail form={mgr.formData} />

            {/* FIX: pass mgr.formData (fresh) and role (normalized string) */}
            <ApprovalPanel
              form={mgr.formData}
              apiPath={ep}
              onRefresh={mgr.refreshDetail}
              role={role}
            />

            <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
              <Button variant="outlined" onClick={() => mgr.setView("list")}>Back to List</Button>
              <Button variant="outlined" startIcon={<Print />} onClick={() => window.print()}>Print</Button>
            </Box>
          </>
        )}

        <SnackBarComponent
          open={mgr.snack.open} message={mgr.snack.message} severity={mgr.snack.severity}
          onClose={() => mgr.setSnack((s) => ({ ...s, open: false }))}
        />
      </Box>
    );
  };

  return (
    <Box sx={{ width: "100%", mt: 2, borderRadius: 2, boxShadow: "0 4px 12px rgba(0,0,0,0.08)", backgroundColor: "#fff" }}>
      <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0", background: "rgba(25,118,210,0.04)" }}>
        <Typography variant="h5" fontWeight="bold">
          Asset Management — Seized Movables &amp; Immovables
        </Typography>
        <Typography variant="caption" color="text.secondary">
          SPLOCA Flow: Shirastedar → then Tahsildar / AC / JS / SPLOCA can act in <strong>any order</strong>
          &nbsp;|&nbsp;
          RC Flow: Shirastedar → then CA / RC can act in <strong>any order</strong>
          &nbsp;|&nbsp; SPLOCA / Admin can <strong>finalise directly</strong>
        </Typography>
      </Box>

      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ borderBottom: "1px solid #e0e0e0" }}>
        {TABS.map((t, i) => <Tab key={i} label={t.label} />)}
      </Tabs>

      <Box sx={{ p: 3 }}>
        {tab === 0 && renderTab(
          reg,
          <RegisterSeizedMovableForm
            d={reg.formData} ro={reg.view === "detail"} set={reg.set}
            items={reg.items} setItems={reg.setItems} onFESelect={reg.handleFESelect}
          />,
          "Register of Seized Movables",
          "/legal/asset/register-seized-movable/",
        )}
        {tab === 1 && renderTab(
          immov,
          <RegisterImmovableForm
            d={immov.formData} ro={immov.view === "detail"} set={immov.set}
            onFESelect={immov.handleFESelect}
            onFileChange={(f) => immov.setDecreeFile(f)}
          />,
          "Register of Immovables",
          "/legal/asset/register-immovable/",
        )}
      </Box>
    </Box>
  );
};